import { Outlet } from "react-router-dom";
import styled from "styled-components";
import {
  DivContent,
  DivMain,
  DivNavigation,
} from "components/layout/style/layout_common.style";
import { Toaster } from "react-hot-toast";
import AdmMenu from "./AdmMenu";

export default function AdminLayout() {
  return (
    <DivMain>
      <DivNavigation>
        <AdmMenu />
      </DivNavigation>

      <Toaster />

      {/* Sadržaj koji se pomera kada je meni otvoren */}
      <DivContent>
        <Outlet />
      </DivContent>
    </DivMain>
    // <Page>
    //   <FullWidth>
    //     {/* SIDE MENU */}
    //     <div>
    //       <SideMenu />
    //     </div>

    //     {/* CENTRAL CONTENT */}
    //     <div style={{ marginLeft: "15%", marginTop: "-12%" }}>
    //       <Outlet />
    //     </div>
    //   </FullWidth>
    // </Page>
  );
}

const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
`;

const FullWidth = styled.div`
  width: 100%;
`;
